import { generateCSSRule, generateCSSSupportRule, getRuleScore } from 'fela-utils';

import insertRuleInDevMode from './insertRuleInDevMode';

export default function insertRule(_ref, renderer, node) {
  var selector = _ref.selector,
      declaration = _ref.declaration,
      support = _ref.support,
      pseudo = _ref.pseudo;

  // only use insertRule in production as browser devtools might have
  // weird behavior if used together with insertRule at runtime
  if (renderer.devMode) {
    return insertRuleInDevMode(renderer, node);
  }

  try {
    var score = getRuleScore(renderer.ruleOrder, pseudo);
    var cssRules = node.sheet.cssRules;

    var index = cssRules.length;

    // TODO: (PERF) instead of checking the score every time
    // we could save the latest score=0 index to quickly inject
    // basic styles and only check for score!=0 (e.g. pseudo classes)
    for (var i = 0, len = cssRules.length; i < len; ++i) {
      if (cssRules[i].score > score) {
        index = i;
        break;
      }
    }

    var cssRule = generateCSSRule(selector, declaration);

    if (support.length > 0) {
      var cssSupportRule = generateCSSSupportRule(support, cssRule);
      node.sheet.insertRule(cssSupportRule, index);
    } else {
      node.sheet.insertRule(cssRule, index);
    }

    cssRules[index].score = score;
  } catch (e) {
    console.warn('An error occurred while inserting the rules into DOM.\n', declaration.replace(/;/g, ';\n'), e);
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-dom/es/dom/connection/insertRule.js
// module id = 1177
// module chunks = 0